var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2646 27.7083L25.827 14.1604C26.8752 13.1123 27.4641 11.6907 27.4641 10.2083C27.4641 8.72602 26.8752 7.30441 25.827 6.25625C24.7789 5.2081 23.3573 4.61925 21.875 4.61925C20.3926 4.61925 18.971 5.2081 17.9229 6.25625L2.09997 22.0938C1.83554 22.3522 1.67916 22.7015 1.66247 23.0708L1.4583 29.1667C1.45129 29.3659 1.4852 29.5645 1.55794 29.7501C1.63068 29.9357 1.7407 30.1044 1.88122 30.2458C2.16729 30.4964 2.53638 30.6316 2.91663 30.625H3.7333H33.5416V27.7083H12.2646ZM23.7562 8.32709C24.0058 8.57272 24.204 8.86555 24.3393 9.18852C24.4746 9.5115 24.5442 9.85817 24.5442 10.2083C24.5442 10.5585 24.4746 10.9052 24.3393 11.2282C24.204 11.5511 24.0058 11.844 23.7562 12.0896L23.6833 12.1625L19.9208 8.4H19.9937C20.2345 8.14562 20.5235 7.94169 20.8438 7.8001C21.1642 7.65852 21.5095 7.5821 21.8597 7.57532C22.2099 7.56853 22.5579 7.63151 22.8835 7.76057C23.2091 7.88964 23.5058 8.08222 23.7562 8.32709ZM4.56455 23.7563L17.85 10.4563L21.6271 14.2333L8.32705 27.5188L4.37497 27.7083L4.56455 23.7563Z",
    fill: "#479FCB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/feedback.5d8bc0578866212a5d97eb5903421ba0.svg";
export { ForwardRef as ReactComponent };